/**
 * package: com.inq.flash.messagingframework.connectionhandling
 * class: HTTPConnectionHandler
 * root Object
 * @constructor
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler = function(host,_chatID,_params, applicationController) {
	/** @type {number} message count from cookies*/
	this.msgCount = 0;
	this.reconnectAttemptsCount = 0;
	/** @type {number} count of putMsgComplete calls */
	this.putSuccessfulResponseCalledCount = 0;
	/** @type {number} the number of queueMessages that was the last time putMsgComplete was called */
	this.queueMessagesNumber = 0;
	this.params = _params;
	this.connected = false;
	/** @type {boolean} network issue flag (disconnection) */
	this.sendMessageFail = false;
	this.chatLost = false;
	/** @type {number} milliseconds */
	this._responseTimestamp = 0;
	/** @type {?number} */
	this._timerSuccessfulPendingConnection = null;

	// TODO: remove this.chatRouterHosts (unused)
	this.chatRouterHosts = new Array();
	this.chatRouterHost = host;
	this.processMessageQueue = new Array();
	this.messageQueue = [];
	this.messagesInProgress = {};
	this.queueKey = 0;
	this.customerID = com.inq.flash.client.control.FlashVars.getValue("customerID");
	this.conversationID = com.inq.flash.client.control.FlashVars.getValue("conversationID");
	this.forceDisconnected = false;
    this.applicationController = applicationController;
    this.isIE = com.inq.utils.Util.isIE;

	/**
	 * @type {boolean}
	 * It marks that a warning log line was sent to the server about receiving an unknown message.
	 * @see HTTPConnectionHandler.prototype.isUnknownMessage
	 */
	this.invalidMessageIsLogged = false;

	this.setChatID(_chatID);
	/** @type {Array} */
	var hosts = host.split(",");
	var /** @type {number} */ i = 0;
	while(i < hosts.length) {
		this.chatRouterHosts[this.chatRouterHosts.length] = hosts[i];/* this adds one since arrays are zero based*/
		i++;
	}

	this.getMsgLoader = new com.inq.net.URLLoader(this.customerID, com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.GET_MSG_LOADER_TIMEOUT);
	/* set up the http event handling */
	this.getMsgLoader.addEventListener(com.inq.events.Event.NETWORK_ERROR,$bind(this,this.getNetworkErrorHandler));
	this.getMsgLoader.addEventListener(com.inq.events.SecurityErrorEvent.SECURITY_ERROR,$bind(this,this.getRequestSecurityError));
	this.getMsgLoader.addEventListener(com.inq.events.HTTPStatusEvent.HTTP_STATUS,$bind(this,this.getMessageHTTPStatus));
	this.getMsgLoader.addEventListener(com.inq.events.Event.COMPLETE, $bind(this, this.getMsgComplete));
	this.getMsgLoader.addEventListener(com.inq.events.Event.UNAUTHORIZED, $bind(this, this.handleChatLost));
    this.getMsgLoader.addEventListener(com.inq.events.Event.BAD_GATEAWAY, $bind(this, this.handleChatLost));
    this.getMsgLoader.addEventListener(com.inq.events.Event.SERVICE_UNAVAILABLE, $bind(this, this.handleChatLost));
	this.getMsgLoader.addEventListener(com.inq.events.Event.BAD_REQUEST, $bind(this, this.handleUnauthorizedMessage));
	/**
	 * WatchDog will restore polling message from chatrouter, if it is stops by unexpected reason.
	 * @see com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.listenForMessages
	 */
	this.getMsgLoader.addWatchDog(
		this.listenForMessages.bind(this),
		com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.GET_MSG_WATCH_DOG_TIMEOUT_MS,
		"listenForMessages"
	);

	this.getMsgPreLoader = new com.inq.net.URLLoader(this.customerID, com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.GET_MSG_LOADER_TIMEOUT);
	this.getMsgPreLoader.addEventListener(com.inq.events.Event.COMPLETE, $bind(this, this.getMsgCompletePreload));
	this.getMsgPreLoader.addEventListener(com.inq.events.Event.UNAUTHORIZED, $bind(this, this.handleChatLost));
    this.getMsgPreLoader.addEventListener(com.inq.events.Event.BAD_GATEAWAY, $bind(this, this.handleChatLost));
    this.getMsgPreLoader.addEventListener(com.inq.events.Event.SERVICE_UNAVAILABLE, $bind(this, this.handleChatLost));
	this.getMsgPreLoader.addEventListener(com.inq.events.Event.NETWORK_ERROR, $bind(this, this.getPreloadNetworkErrorHandler));
	this.getMsgPreLoader.addEventListener(com.inq.events.Event.BAD_REQUEST, $bind(this, this.handleUnauthorizedMessage));

	this.reconnectGetMessageLoader = new com.inq.net.URLLoader(this.customerID, com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.GET_MSG_LOADER_TIMEOUT);
	this.reconnectGetMessageLoader.addEventListener(com.inq.events.Event.COMPLETE, $bind(this, this.reconnectGetMessageComplete));
	this.reconnectGetMessageLoader.addEventListener(com.inq.events.Event.NETWORK_ERROR, $bind(this, this.handleUnauthorizedMessage));
	this.reconnectGetMessageLoader.addEventListener(com.inq.events.Event.UNAUTHORIZED, $bind(this, this.handleUnauthorizedMessage));
	this.reconnectGetMessageLoader.addEventListener(com.inq.events.Event.BAD_GATEAWAY, $bind(this, this.handleUnauthorizedMessage));
	this.reconnectGetMessageLoader.addEventListener(com.inq.events.Event.SERVICE_UNAVAILABLE, $bind(this, this.handleUnauthorizedMessage));
	this.reconnectGetMessageLoader.addEventListener(com.inq.events.Event.BAD_REQUEST, $bind(this, this.handleUnauthorizedMessage));

	this.useClientProtocol = com.inq.utils.Util.getConfig("useClientProtocol",false);
	this.setSelectedHost();

	/* @deprecated according to RTDEV-10625 */
	//com.inq.flash.client.control.FlashPeer.setCiFunction("ciPrepareUrlForBeacon", this.ciPrepareUrlForBeacon);
};
$hxClasses['com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler'] = com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler;
/** @private @type {Array} */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.__name__ = ["com","inq","flash","messagingframework","connectionhandling","HTTPConnectionHandler"];

/**
 * Returns message queue size
 * @private
 * @this com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler
 * @return {Number}
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.getQueueSize = function() {
    return this.messageQueue.length;
};

/**
 * Returns the first item of message queue
 * @private
 * @this com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler
 * @return {Object} Message context, see HTTPConnectionHandler#sendMessage
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.getQueueFirstItem = function() {
    return this.messageQueue[0];
};

/**
 * Returns an in-progress message by its key, deletes it from the map
 * @private
 * @this com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler
 * @return {Object} Message context, see HTTPConnectionHandler#sendMessage
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.deleteInProgressMsg = function(key) {
	var msgContext = this.messagesInProgress[key];
	delete this.messagesInProgress[key];

	if (msgContext) {
		delete msgContext.key;
	}

	return msgContext;
};

/**
 * putMessageHTTPStatus
 *
 * $type TFun([{ name => event, t => TDynamic(null), opt => false }],TEnum(Void,[]))
 * private function putMessageHTTPStatus(event:Dynamic):Void
 * @private
 * @this com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler
 * @param {null}  event
 * @return {void}
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.putMessageHTTPStatus = function(event) {
};


/**
 * getMessageHTTPStatus
 *
 * $type TFun([{ name => event, t => TDynamic(null), opt => false }],TEnum(Void,[]))
 * private function getMessageHTTPStatus(event:Dynamic):Void
 * @private
 * @this com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler
 * @param {null}  event
 * @return {void}
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.getMessageHTTPStatus = function(event) {
};

/**
 * Sends next communication messages from queue if previous was communication.
 * Fire successes callback if response status is 200-299 or 304,
 * else fire error callback.
 *
 * @param {com.inq.events.Event} event - event
 * @return {void}
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.putMsgComplete = function (event) {
	this.successfulResponseHandler();
	this.putSuccessfulResponseCalledCount++;

	var msgContext = this.deleteInProgressMsg(event.currentTarget.key);

	if (msgContext) {
		if (com.inq.flash.client.data.MessageFields.TYPE_CHAT_COMMUNICATION === msgContext.msg.getMessageType()
			|| com.inq.flash.client.data.MessageFields.TYPE_CHAT_REQUEST === msgContext.msg.getMessageType()
		) {
			this.putSuccessfulResponseCalledCount = 0;
			this.sendCommunicationMessagesFromQueue();
		}
	}

	this.repeatSendCommunicationMessagesFromQueue(event);

	var responseStatus = event.target.responseStatus;

	var isSuccess = responseStatus >= 200 && responseStatus < 300 || responseStatus === 304;

	if (msgContext) {
		if (isSuccess) {
			msgContext.onSuccess(event);
		} else {
			msgContext.onError(event);
		}
	}
};

/**
 * Removes previous message because it was successfully sent to server
 * and sends next communication message from queue.
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.sendCommunicationMessagesFromQueue = function() {
	this.messageQueue.shift();
	var nextMsgContext = this.getQueueFirstItem();
	if (nextMsgContext) {
		this.putMessage(nextMsgContext);
	}
};

/**
 * Resend first message from messageQueue by HTTPConnectionHandler#putMessage
 * if HTTPConnectionHandler#putMsgComplete was called few times without decreasing queue size.
 * @param {com.inq.events.Event} event
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.repeatSendCommunicationMessagesFromQueue = function (event) {
	if (this.getQueueSize() === 0) {
		this.putSuccessfulResponseCalledCount = 0;
		this.queueMessagesNumber = 0;

		return;
	}

	var queueSizeIncreased = this.getQueueSize() > this.queueMessagesNumber;

	if (queueSizeIncreased
		&& this.putSuccessfulResponseCalledCount
			> com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.MAX_NUMBER_OF_PUT_SUCCESSFUL_RESPONSE
	) {
		/**
		 * @see com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.sendMessage
		 * @see com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.putMessage
		 * @type {object}
		 */
		var messageContext = this.getQueueFirstItem();

		if (messageContext.key) {
			/** @type {string} */
			var contextKey = messageContext.key;
			/** @type {object} */
			var deletedContext = this.deleteInProgressMsg(messageContext.key);
			com.inq.flash.client.control.FlashPeer.logWarningToServer(
				"putMsgComplete was called few times, "
				+ "but queue of customer messages size is not decreased."
				+ " Queue size: " + this.getQueueSize() + ","
				+ " Event object: " + JSON.stringify(event) + ","
				+ " context key from message queue: " + contextKey + ","
				+ " message from queue: " + messageContext.msg.toString() + ","
				+ " message from progress: " + deletedContext.msg.toString()
				+ " will be sent again."
			);
		} else {
			com.inq.flash.client.control.FlashPeer.logErrorToServer(
				"First message from queue isn't in progress, so it will be sent "
				+ "one more time. Queue size: " + this.getQueueSize() + ","
				+ " Event object: " + JSON.stringify(event) + ","
				+ " message " + messageContext.msg.toString()
			);
		}

		com.inq.flash.client.control.FlashPeer.sendNetworkBackup();
		this.putSuccessfulResponseCalledCount = 0;
		setTimeout($bind(this, this.putMessage), com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.RETRY_DELAY);
	}

	this.queueMessagesNumber = this.getQueueSize();
};

/**
 * getMsgCompletePreload - Called as the preloading of previous messages are completed.
 *
 * $type TFun([{ name => event, t => TInst(com.inq.events.Event,[]), opt => false }],TEnum(Void,[]))
 * private function getMsgCompletePreload(event:com.inq.events.Event):Void
 * @private
 * @this com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler
 * @param {com.inq.events.Event}  event
 * @return {void}
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.getMsgCompletePreload = function(event) {
    if (this.isUnknownMessage(this.getMsgPreLoader)) {
		this.getMessageFailed(event, this.RETRY_DELAY_FOR_INVALID_MESSAGE);
		return;
	}
	this.successfulResponseHandler();
	try {
		var firstMessageSent = com.inq.flash.client.control.PersistenceManager.GetValue(MESSAGE_COUNT, 0) > 0;
		this.msgCount = this.getMsgCompleteProcessing(this.getMsgPreLoader, firstMessageSent);
		this.applicationController.updateDataInStorage(this.msgCount);
		this.routeQueuedRequests(firstMessageSent);
	} catch( e ) {
		if( js.Boot.__instanceof(e,Error) ) {
			haxe.Log.trace("ERROR: " + Std.string(e),{ fileName : "HTTPConnectionHandler.hx", lineNumber : 907, className : "com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler", methodName : "getMsgCompletePreload", customParams : ["error"]});
		} else throw(e);
	}

	if(!this.forceDisconnected) {
		this.listenForMessages();
		this.applicationController.showIntroductionAfterPreloadMessages();
	}
};

/**
 * Handles response on first GET message request after 'chat.request.reconnect' message.
 * First message after reconnect should be chat.accepted or chat.denied,
 * but if it isn't then send 'chat.request.reconnect' again.
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.reconnectGetMessageComplete = function () {
	if (this.isUnknownMessage(this.reconnectGetMessageLoader)) {
		this.handleUnauthorizedMessage();
		return;
	}

	this.successfulResponseHandler();

	try {
		if (this.validateReconnectStatus(this.reconnectGetMessageLoader)) {
			this.reconnectAttemptsCount = 0;
			this.chatLost = false;
			this.getMsgCompleteProcessing(this.reconnectGetMessageLoader, false);
			this.routeQueuedRequests(false);
		} else if (this.reconnectAttemptsCount
			< com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.MAX_NUMBER_OF_RECONNECT
		) {
			this.reconnectAttemptsCount++;
			this.putMessage();
		} else {
			this.handleUnauthorizedMessage();
		}
		this.applicationController.updateDataInStorage(this.msgCount);
	} catch (e) {
		haxe.Log.trace("ERROR: " + Std.string(e), {
			className: "com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler",
			methodName: "getMsgCompleteRestore",
			customParams: ["error"]
		});
	}
};

/**
 * Validate reconnect status.
 *
 * @param {com.inq.net.URLLoader} loader - message loader
 * @return {boolean} returns true if the type of incoming message is accepted or denied.
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.validateReconnectStatus = function (loader) {
	/** @type {Object} */
	var msgData = loader.data;

	if (msgData != null && typeof msgData == "object") {
		var message = new com.inq.flash.messagingframework.Message();
		message.setData(msgData.messages[0]);
		var messageType = message.getMessageType();

		return messageType === com.inq.flash.client.data.MessageFields.TYPE_CHAT_DENIED_RECONNECT
			|| message.isChatAccepted();
	}

	return false;
};

/**
 * Restart getMessages if we catch status == 0 by previous request
 * @private
 * @return {void}
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.getPreloadNetworkErrorHandler = function() {
	if (!this.forceDisconnected && !this.chatLost) {
		setTimeout(function () {
			this.getMessages();
		}.bind(this), com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.RETRY_DELAY);
	}
};

/**
 * Returns true, if response status is corresponded the empty in accordance with TC architecture.
 *
 * @param {com.inq.net.URLLoader} loader
 * @return {boolean}
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.isEmptyResponseStatusCode = function (loader) {
    return loader.responseStatus == com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.STATUS_CODE_NO_CONTENT // means that we got response with empty message
        // IE 9 can not handle HTTP responses with status code 204 (No Content) properly. Code 1223 is be used instead.
        || loader.responseStatus == com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.STATUS_CODE_NO_CONTENT_IE9; // means that we got response with empty message with IE9 browser
};

/**
 * Returns true when received unknown status code without message data.
 *
 * @param {com.inq.net.URLLoader} loader
 * @return {boolean}
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.isUnknownMessage = function(loader) {
    if (!this.isEmptyResponseStatusCode(loader)
		&& loader.responseStatus != 401) {
        //Check on empty message body
		// or unexpected data in the response body
		/** @type {*} */
		var dataType = loader.data == null ? loader.data : typeof loader.data;
		/** @type {boolean} */
		var responseIsIncorrect = dataType != "object";

		if (responseIsIncorrect && !this.invalidMessageIsLogged) {
			com.inq.flash.client.control.FlashPeer.logWarningToServer(
				"Chat received an invalid message format from the server, type of data: " + dataType
			);
			this.invalidMessageIsLogged = true;
		}

		return responseIsIncorrect;
    }
    return false;
};

/**
 * Event when the message is received via HttpChatController.java
 * @param {com.inq.events.Event} event
 * @returns {void}
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.getMsgComplete = function (event) {
    if (this.isUnknownMessage(this.getMsgLoader)) {
		this.getNetworkErrorHandler(event, this.RETRY_DELAY_FOR_INVALID_MESSAGE);
        return;
    }

	this.successfulResponseHandler();

    try {
		var emptyMessage = this.isEmptyResponseStatusCode(this.getMsgLoader);
		var newCount = this.getMsgCompleteProcessing(this.getMsgLoader, false);
		// in applicationController.restoreTranscript
		// all transcript will be restored only for non async chat
		// because of current implementation
		// it will be fixed in RTDEV-31547
		if (newCount !== this.msgCount && newCount !== this.msgCount + 1) {
			this.applicationController.updateDataInStorage(this.msgCount);
			this.applicationController.restoreTranscript();
			return;
		}
		if (!emptyMessage) {
			this.msgCount = newCount;
		}
		this.applicationController.updateDataInStorage(this.msgCount);
        this.routeQueuedRequests(false);
    } catch (e) {
        haxe.Log.trace("ERROR: " + Std.string(e), {fileName: "HTTPConnectionHandler.js", methodName: "getMsgComplete", customParams: ["error"]});
    }

    if (!this.forceDisconnected) {
        haxe.Log.trace("msgCount = " + this.msgCount, {fileName: "HTTPConnectionHandler.js", methodName: "getMsgComplete"});
        this.listenForMessages();
    } else {
	    haxe.Log.trace("forceDisconnect", {fileName: "HTTPConnectionHandler.js", methodName: "getMsgComplete"});
    }
};

/**
 * getMsgCompleteProcessing
 *
 * $type TFun([{ name => loader, t => TInst(com.inq.net.URLLoader,[]), opt => false },{ name => replay, t => TEnum(Bool,[]), opt => false }],TInst(Int,[]))
 * private function getMsgCompleteProcessing(loader:URLLoader, replay:Bool):Int
 * @private
 * @this com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler
 * @param {com.inq.net.URLLoader}  loader
 * @param {boolean}  replay
 * @return {number} - count of total number of chat communications messages
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.getMsgCompleteProcessing = function(loader, replay) {
	var newCount = this.msgCount;
	try {
        var msgData = loader.data;
		var success = msgData != null && typeof msgData == "object";
		if(success) {
			var messages = msgData["messages"];
			if (com.inq.utils.Util.isNullOrUndefined(msgData["count"])) {
				com.inq.flash.client.control.FlashPeer.logErrorToServer("No \"count\" field in message data: " + JSON.stringify(msgData));
			} else {
				newCount = msgData["count"];
			}

			for (var i = 0; i < messages.length; i++) {
				if (messages[i]) {
					/** @type {com.inq.flash.messagingframework.Message} */
					var message = new com.inq.flash.messagingframework.Message();
					message.setData(messages[i]);

					try {
						if (!replay || this.isMsgReplayable(message)) {
							this.processMessageQueue.push(message);
						}
					} catch (e) {
						haxe.Log.trace("FAILED messageRouter.processMessage: " + message.toString(), {
							fileName: "HTTPConnectionHandler.js",
							methodName: "getMsgCompleteProcessing",
							customParams: ["error"]
						});
					}
				}
			}
		}
	} catch( e ) {
		haxe.Log.trace("Error: " + Std.string(e),{ fileName : "HTTPConnectionHandler.js", lineNumber : 322, className : "com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler", methodName : "getMsgCompleteProcessing", customParams : ["error"]});
	}
	return newCount;
};

/**
 * Returns true if message should be replayable.
 *
 * @param {com.inq.flash.messagingframework.Message} message
 * @return {boolean}
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.isMsgReplayable = function (message) {
	/** @type {string} */
	var msgType = message.getMessageType();
	/** @type {string} */
	var cid = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_CHAT_ID);
	/** @type {string} */
	var state = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_STATE);
	/** @type {boolean} */
	var isThisChatSession = cid == this.chatIDForGetMsg
		&& (msgType == com.inq.flash.client.data.MessageFields.TYPE_CHATLINE
			|| msgType == com.inq.flash.client.data.MessageFields.TYPE_CHAT_COMMUNICATION
			|| msgType == com.inq.flash.client.data.MessageFields.TYPE_CHAT_COMMUNICATION_QUEUE
			|| msgType == com.inq.flash.client.data.MessageFields.TYPE_CHAT_COMMUNICATION_SYSTEM
			|| msgType == com.inq.flash.client.data.MessageFields.TYPE_CHAT_COMMUNICATION_OUTCOME
			|| msgType == com.inq.flash.client.data.MessageFields.TYPE_CHAT_COMMUNICATION_OPENER
		);
	/** @type {boolean} */
	var replayableStateChange = msgType === com.inq.flash.client.data.MessageFields.TYPE_STATE_CHANGE
		&& (state === com.inq.flash.client.data.MessageFields.DATA_CONFERENCE
			|| state === com.inq.flash.client.data.MessageFields.DATA_TRANSFER
			|| state === com.inq.flash.client.data.MessageFields.DATA_STATE_CLOSED
			|| state === com.inq.flash.client.data.MessageFields.DATA_STATE_ASSIGNED
			|| state === com.inq.flash.client.data.MessageFields.DATA_STATE_MOVED_TO_ASYNC
		);

	/** @type {boolean} */
	var replayable = isThisChatSession || replayableStateChange
		|| msgType == com.inq.flash.client.data.MessageFields.TYPE_CHATROOM_MEMBER_CONNECTED
		|| msgType == com.inq.flash.client.data.MessageFields.TYPE_CHAT_COBROWSE
		|| msgType == com.inq.flash.client.data.MessageFields.TYPE_CHAT_AUTOMATON_SETTING
		|| msgType == com.inq.flash.client.data.MessageFields.TYPE_CLIENT_COMMAND
		|| msgType == com.inq.flash.client.data.MessageFields.TYPE_CHAT_AUTOMATON_REQUEST
		|| msgType == com.inq.flash.client.data.MessageFields.TYPE_CHATROOM_MEMBER_LOST
		|| msgType == com.inq.flash.client.data.MessageFields.TYPE_CHAT_SYSTEM
		|| msgType == com.inq.flash.client.data.MessageFields.TYPE_COMMAND
		|| msgType == com.inq.flash.client.data.MessageFields.TYPE_CHAT_AUTOMATON_DATA
		|| msgType == com.inq.flash.client.data.MessageFields.TYPE_CHAT_DENIED
		|| msgType == com.inq.flash.client.data.MessageFields.TYPE_CHAT_DENIED_RECONNECT
		|| msgType == com.inq.flash.client.data.MessageFields.TYPE_NINA_COACH_CHAT_TAKE_OVER;

	return replayable;
};

/**
 * Marks last message with information about new assigned agent with key KEY_LAST_AGENT_ASSIGNED_MESSAGE as true.
 *
 * @param {com.inq.flash.messagingframework.Message[]} messages - messages from chatrouter
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.markLastAssignedMessage = function (messages) {
	for (var i = messages.length - 1; i >= 0; i--) {
		var message = messages[i];

		if (isAssignedMessage(message)) {
			message.addProperty(com.inq.flash.client.data.MessageFields.KEY_LAST_AGENT_ASSIGNED_MESSAGE, "true");

			return;
		}
	}

	function isAssignedMessage(msg) {
		return msg.isChatAccepted()
			|| msg.isChatTransfer()
			|| msg.isChatConference()
			|| msg.isMessageType(com.inq.flash.client.data.MessageFields.TYPE_CHATROOM_MEMBER_CONNECTED)
			|| msg.isMessageType(com.inq.flash.client.data.MessageFields.TYPE_NINA_COACH_CHAT_TAKE_OVER);
	}
};

/**
 * routeQueuedRequests
 *
 * $type TFun([{ name => replay, t => TEnum(Bool,[]), opt => false }],TEnum(Void,[]))
 * private function routeQueuedRequests(replay:Bool)
 * @private
 * @this com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler
 * @param {boolean}  replay
 * @return {void}
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.routeQueuedRequests = function(replay) {
	/** @type {com.inq.flash.messagingframework.Message} */
	var msg;

	if (replay) {
		this.markLastAssignedMessage(this.processMessageQueue);
	}

	while (this.processMessageQueue.length > 0) {
		msg = this.processMessageQueue.shift();

		if (replay) {
			msg.addProperty(com.inq.flash.client.data.MessageFields.KEY_REPLAY, "1");
		}
		this.messageRouter.processMessage(msg);
	}
	var handler = this.messageRouter.getHandlerByPrefix(com.inq.flash.client.data.MessageFields.TYPE_CLIENT_COMMAND);
	if (handler) {
		handler.runCommands();
	}
};


/**
 * putRequestSecurityError
 *
 * private function putRequestSecurityError(event:Dynamic):Void
 * @private
 * @this com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler
 * @param {com.inq.events.Event}  event
 * @return {void}
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.putRequestSecurityError = function(event) {
	this.putNetworkErrorHandler(event);
};


/**
 * getRequestSecurityError
 *
 * private function getRequestSecurityError(event:Dynamic):Void
 * @private
 * @this com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler
 * @param {com.inq.events.Event}  event
 * @return {void}
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.getRequestSecurityError = function(event) {
	this.putNetworkErrorHandler(event);
    this.sendMessageFail = true;
};

/**
 * Deletes message from messagesInProgress.
 * Calls putMessage if message should be send to server.
 * @param {com.inq.events.Event} event
 * @return {void}
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.putMessageFailed = function (event) {
	var msgContext = this.deleteInProgressMsg(event.currentTarget.key);

	if (msgContext) {
		if (com.inq.flash.client.data.MessageFields.TYPE_CHAT_COMMUNICATION === msgContext.msg.getMessageType()
			|| com.inq.flash.client.data.MessageFields.TYPE_CHAT_REQUEST_RECONNECT === msgContext.msg.getMessageType()
			|| com.inq.flash.client.data.MessageFields.TYPE_CHAT_REQUEST === msgContext.msg.getMessageType()
		) {
			setTimeout($bind(this, this.putMessage), com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.RETRY_DELAY);
		}

		msgContext.onError(event);
	}
};

/**
 * Handles connection issue for POST requests.
 * @param {com.inq.events.Event} event
 * @return {void}
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.putNetworkErrorHandler = function (event) {
	this.failedResponseHandler();
	this.putMessageFailed(event);
};

/**
 * getNetworkErrorHandler
 *
 * @private
 * @this com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler
 * @param {com.inq.events.Event} event
 * @param {number=} retryDelay - defines the delay before sending the next request
 * @return {void}
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.getNetworkErrorHandler = function(event, retryDelay) {
	// Do not need processing network error when connection is disabled.
	// E.g. this can occur when pending request was aborted,
	// in this case status will be 0 and will be fired NETWORK_ERROR handler.
	if (!this.forceDisconnected) {
		this.failedResponseHandler();
		this.getMessageFailed(event, retryDelay);
	}
};

/**
 * getMessageFailed
 *
 * @private
 * @this com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler
 * @param {com.inq.events.Event} event
 * @param {number=} retryDelay - defines the delay before sending the next request,
 *  default value com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.RETRY_DELAY
 * @return {void}
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.getMessageFailed = function(event, retryDelay) {
	// Do not need sending the new request when connection is disabled.
	if (!this.forceDisconnected && !this.chatLost) {
		retryDelay = retryDelay || com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.RETRY_DELAY;
		window.setTimeout($bind(this, this.listenForMessages), retryDelay);
	}
};

/**
 * getConnectionType
 *
 * $type TFun([],TInst(String,[]))
 * public function getConnectionType():String
 * @public
 * @this com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler
 * @return {string}
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.getConnectionType = function() {
	return com.inq.flash.messagingframework.FlashMessagingFramework.CONNECTION_TYPE_HTTP;
};

/**
 * abort get message already sent via postToServer to prevent unathorized errors
 * @private
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.abortGetMessage = function() {
	this.getMsgLoader.cancelLoad();
};

/**
 * Creates new putMsgLoader and sends put messages to server.
 * If message context is empty get first message from queue
 * (queue contains only communication and request reconnect messages)
 * @param {Object=} msgContext
 * @return {void}
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.putMessage = function(msgContext) {
	if (this.forceDisconnected) {
		if (msgContext) {
			var forceDisconnectedMessage = "HTTPConnectionHandler.prototype.putMessage: Failed to send message, forceDisconnected. " + msgContext.msg.toString();
			var forceDisconnectedError = new Error(forceDisconnectedMessage);
			com.inq.flash.client.control.FlashPeer.logError(forceDisconnectedMessage, forceDisconnectedError);
		}

		return;
	}

	if (!msgContext) {
		msgContext = this.getQueueFirstItem();
	}

	/** @type {string} */
	var host = this.getSelectedHost();
	var putMsgURL = host + com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.MESSAGE_BASE_URL + "?" + msgContext.msg.serializeToURL();

	/** @type {com.inq.net.URLRequest} */
	var putMsgRequest = new com.inq.net.URLRequest(putMsgURL);

	try {
		/** @type {com.inq.net.URLLoader} */
		var putMsgLoader = new com.inq.net.URLLoader(this.customerID);
		putMsgLoader.addEventListener(com.inq.events.HTTPStatusEvent.HTTP_STATUS,$bind(this,this.putMessageHTTPStatus));
		putMsgLoader.addEventListener(com.inq.events.SecurityErrorEvent.SECURITY_ERROR,$bind(this,this.putRequestSecurityError));
		putMsgLoader.addEventListener(com.inq.events.Event.NETWORK_ERROR,$bind(this,this.putNetworkErrorHandler));
		putMsgLoader.addEventListener(com.inq.events.Event.BAD_REQUEST, $bind(this, this.handleUnauthorizedMessage));
		putMsgLoader.addEventListener(com.inq.events.Event.UNAUTHORIZED, $bind(this, this.putMessageFailed));
		putMsgLoader.addEventListener(com.inq.events.Event.BAD_GATEAWAY, $bind(this, this.putMessageFailed));
		putMsgLoader.addEventListener(com.inq.events.Event.SERVICE_UNAVAILABLE, $bind(this, this.putMessageFailed));
		putMsgLoader.addEventListener(com.inq.events.Event.COMPLETE, $bind(this, this.putMsgComplete));
		var key = "send" + (++this.queueKey);
		msgContext.key = key;
		this.messagesInProgress[key] = msgContext;
		putMsgLoader.load(putMsgRequest, key, true, com.inq.flash.client.control.FlashPeer.getFPSessionID()); // send POST
	} catch (e) {
		var errorMessage = "HTTPConnectionHandler.prototype.putMessage: Failed to send message. " + msgContext.msg.toString();
		com.inq.flash.client.control.FlashPeer.logError(errorMessage, e);
	}
};

/**
 * Creates message context and sends message or puts it to queue.
 * @param {com.inq.flash.messagingframework.Message} message
 * @param {function=} successListener Optional callback function on success message delivery.
 * @param {function=} errorListener Optional callback function on error message delivery.
 * @return {void}
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.sendMessage = function(message, successListener, errorListener) {
	var msgContext = {
		msg: message,
		onSuccess: (typeof successListener == "function" ? successListener : $noop),
		onError: (typeof errorListener == "function" ? errorListener : $noop)
	};

	/** @type {boolean} is message should be added only to queue without sending to server now */
	var messagesInQueue = false;

	switch (message.getMessageType()) {
		case com.inq.flash.client.data.MessageFields.TYPE_CHAT_COMMUNICATION:
			this.messageQueue.push(msgContext);
			messagesInQueue = this.getQueueSize() > 1;
			break;

		case com.inq.flash.client.data.MessageFields.TYPE_CHAT_REQUEST:
		case com.inq.flash.client.data.MessageFields.TYPE_CHAT_REQUEST_RECONNECT:
			/*
			 * reconnect message should be added to top of queue
			 * to be able to send it first if communication message is failed
			 */
			this.messageQueue.unshift(msgContext);
			messagesInQueue = this.getQueueSize() > 1;
			break;

		case com.inq.flash.client.data.MessageFields.TYPE_CHAT_EXIT:
			this.abortGetMessage();
			break;

		default:
		// do nothing
	}

	if (!messagesInQueue) {
		this.putMessage(msgContext);
	} else if (message.getMessageType() === com.inq.flash.client.data.MessageFields.TYPE_CHAT_REQUEST) {
		com.inq.flash.client.control.FlashPeer.logErrorToServer(
			"HTTPConnectionHandler messages queue isn't empty, but chat.request "
			+ "still wasn't sent! This behavior is unexpected and should be "
			+ "additionally investigated, because in this case, the chat probably was not started."
		);
	}
};

com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.handleUnauthorizedMessage = function () {
	/* If from request we are got 401 (old "CHAT_REQUEST_NEEDED") status code
	 * because Message Connection to the chatroom has been lost and the customer has lost connection,
	 * then we should notify customer about failing.
	 * See the ticket RTDEV-14330
	 * See previous changes: RTDEV-9787
	 */
	haxe.Log.trace("status response 401", {
		fileName: "HTTPConnectionHandler.js",
		methodName: "handleUnauthorizedMessage"
	});

	if (com.inq.flash.client.control.FlashVars.isSecureWithCustToken()) {
		// For security, we close chat if 401 occurs.
		com.inq.flash.client.chatskins.SkinControl.closeChat();
	} else {
		this.applicationController.onLostConnection();
	}
};

/**
 * putChatExitMsgComplete
 * Upon completion of the "putChatExitMsgComplete" we need to:
 * 1) disable all chat router communications
 * 2) dispatch the "chat.exit" message back to the client
 *
 * PLEASE NOTE:  The ChatExitMessage has a chat ID of "", this way we can tell
 * in the message handler that this is from the client and not from the agent.
 *
 * $type TFun([{ name => event, t => TDynamic(null), opt => false }],TEnum(Void,[]))
 * private function putChatExitMsgComplete(event:Dynamic):Void
 * @private
 * @this com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler
 * @param {null}  event
 * @return {void}
 *
 * @deprecated
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.putChatExitMsgComplete = function(event) {
	// haxe.Log.trace("putChatExitMsgComplete",{ fileName : "HTTPConnectionHandler.hx", lineNumber : 550, className : "com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler", methodName : "putChatExitMsgComplete"});
	this.disable();
	/** @type {com.inq.flash.messagingframework.Message} */
	var message = new com.inq.flash.client.data.ChatExitMessage("");
	this.messageRouter.processMessage(message);
};

/**
 * When client's ChatRouter lost, we should send chat.request.reconnect
 * to restore connection to chatroom on another ChatRouter.
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.handleChatLost = function () {
	if (this.forceDisconnected) {
		return;
	}

	if (com.inq.flash.client.control.FlashVars.isSecureWithCustToken()) {
		// For security, we close chat if 401 occurs.
		com.inq.flash.client.chatskins.SkinControl.closeChat();
	} else if (!this.chatLost) {
		this.chatLost = true;
		this.abortGetMessage();
		this.applicationController.sendChatRequestMessage(true);
	}
};

/**
 * listenForMessages
 *
 * @private
 * @this com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler
 * @return {void}
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.listenForMessages = function() {
	// Need to check "forceDisconnected" flag because this method can be called by timeout.
	// See the method: HTTPConnectionHandler.prototype.getMessageFailed
	if (!this.forceDisconnected) {
		this.abortGetMessage();
		var urlGetMsg = this.generateMessageURL(this.msgCount);
		this.getMsgLoader.load(new com.inq.net.URLRequest(urlGetMsg), null, false, com.inq.flash.client.control.FlashPeer.getFPSessionID());
		this.pendingConnectionEstablished();
	}
};

/**
 * isAutomaton
 * if this is an automaton request, then return true;
 *
 * $type TFun([],TEnum(Bool,[]))
 * private function isAutomaton():Bool
 * @private
 * @this com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler
 * @return {boolean} - true/false
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.isAutomaton = function() {
	/** @type {?string} */
	var b = com.inq.flash.client.control.FlashVars.getValue("automatonId");
	return b != null;
};


/**
 * setChatID
 *
 * $type TFun([{ name => chatID, t => TInst(String,[]), opt => false }],TEnum(Void,[]))
 * public  function setChatID(chatID:String)
 * @public
 * @this com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler
 * @param {string}  chatID
 * @return {void}
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.setChatID = function(chatID) {
	this.chatIDForGetMsg = chatID;
};


/**
 * connectionComplete
 *
 * TODO: check that this function deprecated, RTDEV-14129
 *
 * $type TFun([{ name => event, t => TDynamic(null), opt => false }],TEnum(Void,[]))
 * private function connectionComplete(event:Dynamic):Void
 * @private
 * @this com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler
 * @param {null}  event
 * @return {void}
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.connectionComplete = function(event) {
	if (event == null) {
		if (!this.isConnected() && !this.forceDisconnected) {
			this.connected = true;
			this.framework.connectionSuccesful(this);
			this.applicationConnectionEventHandler.connectionSuccessful();
			/* this will result in a chat.request being sent in the ApplicationController.connectionEstablished*/
		}
	}
};


/**
 * establishConnectionRequest
 *
 * $type TFun([],TEnum(Void,[]))
 * private function establishConnectionRequest()
 * @private
 * @this com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler
 * @return {void}
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.establishConnectionRequest = function() {
	// haxe.Log.trace("", {fileName: "HTTPConnectionHandler.js", methodName: "establishConnectionRequest"});
	if(!this.isConnected() && !this.forceDisconnected) {
		this.connected = true;
		this.framework.connectionSuccesful(this);
		this.applicationConnectionEventHandler.connectionSuccessful();/* this will result in a chat.request being sent in the ApplicationController.connectionEstablished*/
	}
};


/**
 * connect
 *
 * @public
 * @this com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler
 * @return {void}
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.connect = function() {
    this.connectionRequestedByDemand = true;
	this.establishConnection();
};

/**
 * establishConnection
 *
 * @public
 * @this com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler
 * @return {void}
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.establishConnection = function() {
	if (this.connectionRequestedByDemand && !com.inq.flash.client.chatskins.SkinControl.asyncTranscriptLoading) {
		var iMsgRereadLmt = com.inq.flash.client.control.PersistenceManager.GetValue(MESSAGE_COUNT,0);
		//for async chat we need to re-check if there is active chatroom when we send initial message
		if (this.applicationController.getChat().isAsyncChat() && iMsgRereadLmt === 0) {
			com.inq.flash.client.control.FlashPeer.getActiveChatroomId(
				function (chatID, customerID, asyncReconnect) {
					this.applicationController.getChat().setAsyncReconnect(asyncReconnect);
					this.applicationController.setChatID(chatID);
					this.applicationController.setCustomerID(customerID);
					this.setChatID(chatID);
					this.setCustomerID(customerID);
					this.establishConnectionRequest();
				}.bind(this),
				this.establishConnectionRequest.bind(this)
			);
		} else {
			this.establishConnectionRequest();
			if (com.inq.flash.client.control.FlashPeer.isPersistentWindow()) {
				if (iMsgRereadLmt < this.applicationController.msgcntAtEntry) {
					iMsgRereadLmt = this.applicationController.msgcntAtEntry;
				}
			}
			/* Start loading messages. */
			if (iMsgRereadLmt > 0) {
				this.getMessages();
			}
		}
	}
};


/**
 * setSelectedHost
 *
 * @private
 * @this com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler
 * @return {void}
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.setSelectedHost = function() {
	var protocol = this.useClientProtocol ? window.location.protocol : "https:";

	if (this.chatRouterHost.toLowerCase().indexOf("http") != 0) {
		this.selectedHost = protocol + "//" + this.chatRouterHost;
	} else {
		this.selectedHost = this.chatRouterHost.replace("http:", protocol);
	}
};


/**
 * getSelectedHost
 *
 * @private
 * @this com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler
 * @return {string}
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.getSelectedHost = function() {
	return this.selectedHost;
};


/**
 * disconnect
 *
 * @public
 * @this com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler
 * @return {void}
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.disconnect = function(reason) {
	if (this.forceDisconnected || this.applicationController.clientDisconnect) {
		return;
	}
	if (typeof reason === "undefined") {
		reason = com.inq.flash.client.chatskins.SkinControl.CLOSE_CHAT_REASON_UNKNOWN;
	}

	this.connected = false;
	this.forceDisconnected = true;
	//TODO: create "putMsgLoader" property instead. Similar to getMsgLoader. RTDEV-16549
	var putMsgLoader = new com.inq.net.URLLoader(this.customerID);
	putMsgLoader.addEventListener(com.inq.events.Event.COMPLETE,$bind(this,this.putMsgComplete));
	putMsgLoader.addEventListener(com.inq.events.Event.UNAUTHORIZED, $bind(this, this.handleUnauthorizedMessage));
	putMsgLoader.addEventListener(com.inq.events.Event.BAD_GATEAWAY, $bind(this, this.handleUnauthorizedMessage));
	putMsgLoader.addEventListener(com.inq.events.Event.SERVICE_UNAVAILABLE, $bind(this, this.handleUnauthorizedMessage));
	/** @type {string} */
	var endChatURL = this.getSelectedHost() + "/chatrouter/chat/closeChat?rand=" + Math.random() + "&" + com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.CLOSE_REASON + reason;
	if(this.chatIDForGetMsg != null && this.chatIDForGetMsg != "") endChatURL += "&" + com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.ENGAGEMENT_ID_PARAM + this.chatIDForGetMsg;
	/** @type {com.inq.net.URLRequest} */
	var endChatRequest = new com.inq.net.URLRequest(endChatURL);
	putMsgLoader.load(endChatRequest);
};


/**
 * getMessagingFramework
 *
 * $type TFun([],TInst(com.inq.flash.messagingframework.FlashMessagingFramework,[]))
 * public function getMessagingFramework():FlashMessagingFramework
 * @public
 * @this com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler
 * @return {com.inq.flash.messagingframework.FlashMessagingFramework}
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.getMessagingFramework = function() {
	return this.framework;
};


/**
 * setMessagingFramework
 *
 * $type TFun([{ name => framework, t => TInst(com.inq.flash.messagingframework.FlashMessagingFramework,[]), opt => false }],TEnum(Void,[]))
 * public function setMessagingFramework(framework:FlashMessagingFramework):Void
 * @public
 * @this com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler
 * @param {com.inq.flash.messagingframework.FlashMessagingFramework}  framework
 * @return {void}
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.setMessagingFramework = function(framework) {
	this.framework = framework;
};


/**
 * setMessageRouter
 *
 * $type TFun([{ name => messageRouter, t => TInst(com.inq.flash.messagingframework.MessageRouter,[]), opt => false }],TEnum(Void,[]))
 * public function setMessageRouter(messageRouter:MessageRouter):Void
 * @public
 * @this com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler
 * @param {com.inq.flash.messagingframework.MessageRouter}  messageRouter
 * @return {void}
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.setMessageRouter = function(messageRouter) {
	this.messageRouter = messageRouter;
};


/**
 * Returns the boolean flag meaning that chat application can communicate with the chat router.
 *
 * @public
 * @this com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler
 * @return {boolean}
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.isConnected = function() {
	return this.connected;
};


/**
 * setApplicationConnectionEventHandler
 *
 * $type TFun([{ name => applicationConnectionEventHandler, t => TInst(com.inq.flash.messagingframework.connectionhandling.ApplicationConnectionEventHandler,[]), opt => false }],TEnum(Void,[]))
 * public function setApplicationConnectionEventHandler(applicationConnectionEventHandler:ApplicationConnectionEventHandler):Void
 * @public
 * @this com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler
 * @param {com.inq.flash.client.control.ClientConnectionEventHandler}  applicationConnectionEventHandler
 * @return {void}
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.setApplicationConnectionEventHandler = function(applicationConnectionEventHandler) {
	this.applicationConnectionEventHandler = applicationConnectionEventHandler;
};


/**
 * setHost
 *
 * $type TFun([{ name => host, t => TInst(String,[]), opt => false }],TEnum(Void,[]))
 * public function setHost(host:String):Void
 * @public
 * @this com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler
 * @param {string}  host
 * @return {void}
 *
 * @todo remove this method since it is deprecated and no longer used
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.setHost = function(host) {
};


/**
 * setParam
 *
 * $type TFun([{ name => name, t => TInst(String,[]), opt => false },{ name => valu, t => TDynamic(null), opt => false }],TEnum(Void,[]))
 * public function setParam(name:String,valu:Dynamic):Void
 * @public
 * @this com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler
 * @param {string}  name
 * @param {null}  valu
 * @return {void}
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.setParam = function(name,valu) {
	this[name] = valu;
};


/**
 * getMessages
 *
 * @private
 * @this com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler
 * @return {void}
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.getMessages = function () {
	if (!this.forceDisconnected) {
		/** @type {string} */
		var urlGetMsg = this.generateMessageURL(null, true);
		this.getMsgPreLoader.load(new com.inq.net.URLRequest(urlGetMsg), null, false, com.inq.flash.client.control.FlashPeer.getFPSessionID());
	}
};

/**
 * Ask the server about the current state of the chat
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.sendReconnectGetMessage = function () {
	if (!this.forceDisconnected) {
		/** @type {string} */
		var urlGetMsg = this.generateMessageURL();
		this.reconnectGetMessageLoader.load(
			new com.inq.net.URLRequest(urlGetMsg),
			null,
			false,
			com.inq.flash.client.control.FlashPeer.getFPSessionID()
		);
	}
};

/**
 * getParams
 *
 * $type TFun([{ name => keyName, t => TInst(String,[]), opt => false }],TDynamic(null))
 * private function getParams(keyName:String):Dynamic
 * @private
 * @this com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler
 * @param {string}  keyName
 * @return {null}
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.getParams = function(keyName) {
	return this.params[keyName];
};


/**
 * acknowledgePersistentActive
 *
 * $type TFun([{ name => chatID, t => TInst(String,[]), opt => false },{ name => protoDomain, t => TInst(String,[]), opt => false },{ name => clientProtoDomain, t => TInst(String,[]), opt => false },{ name => needNewOpener, t => TEnum(Bool,[]), opt => false },{ name => messageCount, t => TInst(String,[]), opt => false }],TEnum(Void,[]))
 * public function acknowledgePersistentActive(chatID:String, protoDomain:String, clientProtoDomain:String, needNewOpener:Bool, messageCount:String):Void
 * @public
 * @this com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler
 * @param {string}  chatID
 * @param {string}  protoDomain
 * @param {string}  clientProtoDomain
 * @param {boolean}  needNewOpener
 * @return {void}
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.acknowledgePersistentActive = function(chatID,protoDomain,clientProtoDomain,needNewOpener) {
	/** @type {string} */
	var newLoc = "";
	/** @type {string} */
	var putMsgURL = this.getSelectedHost() + "/chatrouter/chat/ackPersistentActive.js?engagementID=" + this.chatIDForGetMsg + "&op=" + Std.string(needNewOpener) + "&pd=" + protoDomain + "&r=" + Math.round(123456789.0 * Math.random());
	if(protoDomain != clientProtoDomain) {
		this.applicationController.noUnload();
		newLoc = window.parent.location.href;
		newLoc = newLoc.split(protoDomain).join(clientProtoDomain);
		newLoc = newLoc.split("#")[0];
		putMsgURL += "&xfr=" + StringTools.urlEncode(newLoc);
	}

	/** @type {com.inq.net.URLRequest} */
	var ackPersistentRequest = new com.inq.net.URLRequest(putMsgURL);
	try {
		this.ackPersistentLoader = new com.inq.net.URLLoader(this.customerID);
		this.ackPersistentLoader.addEventListener(com.inq.events.Event.COMPLETE,function(event) {
		});
		this.ackPersistentLoader.load(ackPersistentRequest);
	} catch( e ) {
		if( js.Boot.__instanceof(e,Error) ) {
			haxe.Log.trace("" + Std.string(e),{ fileName : "HTTPConnectionHandler.hx", lineNumber : 205, className : "com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler", methodName : "acknowledgePersistentActive", customParams : ["error"]});
		} else throw(e);
	}
};


/**
 * sendChatHTML
 *
 * $type TFun([],TEnum(Void,[]))
 * public function sendChatHTML():Void
 * @public
 * @this com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler
 * @return {void}
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.sendChatHTML = function() {
	/** @type {string} */
	var chatHTML = StringTools.urlEncode(document.getElementById("me").innerHTML);
	/** @type {string} */
	var sendHtmlURL = this.getSelectedHost() + "/chatrouter/chat/sendHTML.js?engagementID=" + this.chatIDForGetMsg + "&r=" + this.rand() + "&h=";
	/** @type {number} */
	var limit = 2000 - sendHtmlURL.length;
	if(limit > chatHTML.length) limit = chatHTML.length;
	while(chatHTML.length > 0) {
		/** @type {string} */
		var url = sendHtmlURL + HxOverrides.substr(chatHTML,0,limit);
		/** @type {com.inq.net.URLLoader} */
		var sendHtmlLoader;
		/** @type {com.inq.net.URLRequest} */
		var sendHtmlRequest = new com.inq.net.URLRequest(url);
		sendHtmlLoader = new com.inq.net.URLLoader(this.customerID);
		sendHtmlLoader.addEventListener(com.inq.events.Event.COMPLETE,function(event) {
		});

		sendHtmlLoader.load(sendHtmlRequest);
		chatHTML = HxOverrides.substr(chatHTML,limit + 1,null);
	}
};


/**
 * rand
 *
 * $type TFun([],TInst(Int,[]))
 * private function rand()
 * @private
 * @this com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler
 * @return {number}
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.rand = function() {
	return Math.round(123456789.0 * Math.random());
};


/**
 * acknowledgeChatActive
 *
 * $type TFun([{ name => chatID, t => TInst(String,[]), opt => false }],TEnum(Void,[]))
 * public function acknowledgeChatActive(chatID:String):Void
 * @public
 * @this com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler
 * @param {string}  chatID
 * @return {void}
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.acknowledgeChatActive = function(chatID) {
	/** @type {string} */
	var putMsgURL = this.getSelectedHost() + "/chatrouter/chat/ackChatActive" + "?engagementID=" + this.chatIDForGetMsg + "&rand=" + Math.random();
	/** @type {com.inq.net.URLRequest} */
	var putMsgRequest = new com.inq.net.URLRequest(putMsgURL);
	try {
		// haxe.Log.trace("in HTTP sendMessage, about to request put: " + putMsgURL,{ fileName : "HTTPConnectionHandler.hx", lineNumber : 140, className : "com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler", methodName : "acknowledgeChatActive"});

		/** @type {com.inq.net.URLLoader} */
		var putMsgLoader = new com.inq.net.URLLoader(this.customerID);
		putMsgLoader.load(putMsgRequest);
	} catch( e ) {
		if( js.Boot.__instanceof(e,Error) ) {
			haxe.Log.trace("" + Std.string(e),{ fileName : "HTTPConnectionHandler.hx", lineNumber : 145, className : "com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler", methodName : "acknowledgeChatActive", customParams : ["error"]});
		} else throw(e);
	}
};


/**
 * enable
 *
 * $type TFun([],TEnum(Void,[]))
 * public function enable():Void
 * @public
 * @this com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler
 * @return {void}
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.enable = function() {
	this.forceDisconnected = false;
	this.listenForMessages();
};



com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.enableForReEngaging = function() {
	this.forceDisconnected = false;
	this.sendMessageFail = false;
};

/**
 * disable
 *
 * @public
 * @this com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler
 * @return {void}
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.disable = function() {
	this.abortGetMessage();
	this.clearSuccessfulPendingConnectionTimer();
	this.connected = false;
	this.forceDisconnected = true;
};

/**
 * Returns true if last message returned fail status to mark that there is no network connection
 * @return {Boolean}
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.isSendMessageFail = function() {
	return this.sendMessageFail;
};

/**
 * Returns url for GET request to chatrouter
 * Example of request urls:
 * https://chatrouterv3.inq.com/chatrouter/chat/message?customerID={custID}&engagementID={chatID}&windowId={windowID}
 * https://chatrouterv3.inq.com/chatrouter/chat/message/1?customerID={custID}&engagementID={chatID}&windowId={windowID}
 * https://chatrouterv3.inq.com/chatrouter/chat/message?customerID={custID}&engagementID={chatID}&requestEntireTranscript=true&windowId={windowID}
 *
 * @param {?number=} mgsCount - message count
 * @param {boolean=} isEntireTranscript - if true then entire transcript
 * parameter should be added
 *
 * @return {string} url for get message
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.generateMessageURL = function (mgsCount, isEntireTranscript) {
	var url = this.getSelectedHost() + com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.MESSAGE_BASE_URL;

	if (mgsCount !== null && mgsCount !== undefined) {
		url += "/" + mgsCount;
	}

	url += "?" + com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.ENGAGEMENT_ID_PARAM
		+ this.chatIDForGetMsg + "&" + com.inq.flash.client.data.MessageFields.WINDOW_ID_PARAM
		+ "=" + com.inq.flash.client.control.FlashVars.getWindowId();

	if (isEntireTranscript) {
		url += "&" + com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.ENTIRE_TRANSCRIPT_PARAM + "true";
	}

	if (com.inq.flash.client.control.FlashVars.isSecureWithCustToken()) {
		var secureCustToken = com.inq.flash.client.control.FlashVars.getPersistentCustomerID();
		url += "&" + com.inq.flash.client.data.MessageFields.KEY_SECURE_CUST_TOKEN
			+ "=" + secureCustToken;
	}

	return url;
};

/**
 * ciPrepareUrlForBeacon
 *
 * This is a public function to call "prepareUrlForBeacon" in CI context
 * Invokes in Inq.FlashPeer
 *
 * @public
 * @this Inq.FlashPeer
 * @return {string}
 *
 * @deprecated according to RTDEV-10625
 *
 * This function/method was used for sending of beacon
 * and according to RTDEV-10625 this function is not used
 * because the sending of beacon mechanism was moved to the postToServer iframe
 * to avoid limitations of CORS in IE9- and for synchronous requests.
 * @see IJSF Chat#setCABeacon
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.ciPrepareUrlForBeacon = function() {
	var connection = Application.application.applicationController.getMessagingFramework().getConnection();
	if (connection) {
		return connection.prepareUrlForBeacon.call(connection);
	} else {
		return "";
	}
};

/**
 * prepareUrlForBeacon
 *
 * This is a public function which processes a connection and prepares the pageUnload URL
 * when occurs the unloading of a window containing a chat.
 * Invokes via "ciPrepareUrlForBeacon" method.
 *
 * @public
 * @this com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler
 * @return {string}
 *
 * @deprecated according to RTDEV-10625
 *
 * This function/method was used for sending of beacon
 * and according to RTDEV-10625 this function is not used
 * because the sending of beacon mechanism was moved to the postToServer iframe
 * to avoid limitations of CORS in IE9- and for synchronous requests.
 * @see IJSF Chat#setCABeacon
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.prepareUrlForBeacon = function() {
	if (this.isConnected() && !this.forceDisconnected) {
		// The bug in IE10-: Anchor “javascript:void(0)” causing window.onbeforeunload to fire on IE (RTDEV-9937)
		if (!this.isIE) {
			// RTDEV-9674:
			// Firefox has an own feature during the processing of XmlHTTPRequest after break the HTTP connection,
			// therefore we need stop to listen of CR response.
			this.disable();
		}

		var url = this.getSelectedHost() + this.MESSAGE_PAGE_UNLOAD;
		url += "?" + this.ENGAGEMENT_ID_PARAM + this.chatIDForGetMsg;
		url += "&" + this.CUSTOMER_ID_PARAM + com.inq.flash.client.control.FlashVars.getValue("customerID");
		url += "&" + com.inq.flash.client.data.MessageFields.WINDOW_ID_PARAM + "=" + com.inq.flash.client.control.FlashVars.getWindowId();
		return url;
	}
};

/**
 * Response timestamp is used for detection the last successful response from the server
 * to monitor the time of the connection issue.
 * If returns 0 that means the response had not received even once.
 * @returns {number} the date in milliseconds elapsed since the UNIX epoch
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype._getResponseTimestamp = function() {
	return this._responseTimestamp;
};

/**
 * The common handler of all successful responses for current connection instance.
 * @returns {void}
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.successfulResponseHandler = function() {
	// Reset 'sendMessageFail' flag for all successful responses.
	// See RTDEV-14654
	if (this.sendMessageFail) {
		this.sendMessageFail = false;
		Application.application.notificationController.showConnectionRestoredMessage();
	}

	this._responseTimestamp = Date.now();
	this.clearSuccessfulPendingConnectionTimer();
};

/**
 * The common handler of all failed responses for current connection instance.
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.failedResponseHandler = function() {
	this.sendMessageFail = true;
	Application.application.notificationController.showConnectionIssuesMessage();
};

/**
 * It's a workaround for case when there is an issue with connection,
 * in this case the response from server will not be received.
 * But for more flexible control we need to detect the case
 * when new pending connection will be established.
 * Will use that fact that new attempt to restore connection will be after RETRY_DELAY timeout,
 * thus timeout for message will be cleared every time after RETRY_DELAY timeout,
 * except the case when connection is waiting for the response from the server more than RETRY_DELAY period,
 * this may mean that connection was restored.
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.pendingConnectionEstablished = function() {
	this.clearSuccessfulPendingConnectionTimer();

	// delay should be more than RETRY_DELAY to catch the moment when connection restored, e.g. in 2 times
	var delay = 2 * com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.RETRY_DELAY;
	this._timerSuccessfulPendingConnection = setTimeout(this.successfulResponseHandler.bind(this), delay);
};

/**
 * Clear the timer '_timerSuccessfulPendingConnection'
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.clearSuccessfulPendingConnectionTimer = function() {
	if (this._timerSuccessfulPendingConnection) {
		clearTimeout(this._timerSuccessfulPendingConnection);
		this._timerSuccessfulPendingConnection = null;
	}
};

/**
 * Updates customer id in HTTPConnectionHandler and in all loaders
 * @param {string} customerID
 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.setCustomerID = function (customerID) {
	this.customerID = customerID;
	this.getMsgLoader.setCustomerID(customerID);
	this.getMsgPreLoader.setCustomerID(customerID);
	this.reconnectGetMessageLoader.setCustomerID(customerID);
};

/** @private @type {string} */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.chatIDForGetMsg = null;
/** @private @type {com.inq.net.URLLoader} */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.ackPersistentLoader = null;
/** @private @type {com.inq.net.URLLoader} */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.putMsgLoader = null;
/** @private @type {boolean} */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.forceDisconnected = null;
/** @private @type {Array} */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.messageQueue = null;
/** @private @type {number} */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.queueKey = null;
/** @private @type {com.inq.net.URLLoader} */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.getMsgCntLoader = null;
/** @private @type {com.inq.net.URLLoader} */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.getMsgPreLoader = null;
/** @private @type {com.inq.net.URLLoader} */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.getMsgLoader = null;
/** @private @type {number} */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.msgCount = null;
/** @private @type {null} */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.params = null;
/** @private @type {com.inq.flash.messagingframework.FlashMessagingFramework} */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.framework = null;
/** @private @type {com.inq.flash.messagingframework.MessageRouter} */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.messageRouter = null;
/** @private @type {com.inq.flash.messagingframework.connectionhandling.ApplicationConnectionEventHandler} */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.applicationConnectionEventHandler = null;
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.__class__ = com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler;
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.__interfaces__ = [com.inq.flash.messagingframework.connectionhandling.ConnectionHandler];
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.ENGAGEMENT_ID_PARAM = "engagementID=";
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.ENTIRE_TRANSCRIPT_PARAM = "requestEntireTranscript=";
/** @deprecated according to RTDEV-10625 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.ENGAGEMENT_ID_PARAM = "engagementID=";
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.MESSAGE_BASE_URL = "/chatrouter/chat/message";
/** @deprecated according to RTDEV-10625 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.MESSAGE_PAGE_UNLOAD = "/chatrouter/chat/pageUnload";
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.RETRY_DELAY = 1000; // in milliseconds
/** @type {number} delay before sending the next request in case of invalid message, in milliseconds */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.RETRY_DELAY_FOR_INVALID_MESSAGE = 5000;
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.STATUS_CODE_NO_CONTENT = 204;
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.STATUS_CODE_NO_CONTENT_IE9 = 1223;
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.STATUS_CODE_AJAX_ABORTED = 0;
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.CUSTOMER_ID_PARAM = "customerID=";
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.CLOSE_REASON = "reason=";
/** @deprecated according to RTDEV-10625 */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.prototype.CUSTOMER_ID_PARAM = "customerID=";
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.GET_MSG_LOADER_TIMEOUT = 35000;
/** @type {number} timeout for restore polling in WatchDog for getMsgLoader */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.GET_MSG_WATCH_DOG_TIMEOUT_MS = 60000;
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.MAX_NUMBER_OF_RECONNECT = 5;
/** @type {number} max number of HTTPConnectionHandler#putMsgComplete calling without sending next customer message */
com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler.MAX_NUMBER_OF_PUT_SUCCESSFUL_RESPONSE = 4;
